interface Props {
  step: number;
  totalSteps: number;
  progress: number;
}

const STEP_LABELS = ['Asosiy', 'Texnik', 'Aloqa'];

export function ProgressHeader({ step, totalSteps, progress }: Props) {
  return (
    <header className="header">
      <h1>Mashina ma'lumotlari</h1>
      <div className="step-indicators">
        {Array.from({ length: totalSteps }, (_, i) => (
          <div
            key={i}
            className={`step-dot ${i + 1 === step ? 'active' : ''} ${i + 1 < step ? 'completed' : ''}`}
          >
            <div className="dot">{i + 1 < step ? '✓' : i + 1}</div>
            <span className="dot-label">{STEP_LABELS[i]}</span>
          </div>
        ))}
      </div>
      <div className="progress">
        <div className="progress-bar" style={{ width: `${progress}%` }} />
      </div>
    </header>
  );
}
